"use strict";

var Backbone = require("backbone");
var _ = require("underscore");
var $ = require("jquery");
Backbone.$ = $;

var debug = require("debug")("views:SearchNextResultsView"); //https://github.com/visionmedia/debug

// Models
var ArticleQueryModel = require("../../search/models/article-query-model");
var UserModel = require("../../common/models/user-model");
var HistoPeriodList = require("../../search/models/histo-period-list");

// Views
var ArticleResultView = require("../../search/views/article-result-view");

var templates = {
    articleNextResult: require("../templates/article-next-result-template.html")
};

/**
 * Retronews SearchNextResultsView : view for the 5 next search results.
 */
module.exports = Backbone.View.extend({

    app: null, // store a reference to global app (mainly for configuration access)
    template: null, // external template
    searchQuery: null, // query de la recherche lancée
    index: false, // index du résultats dans l'ensemble des résultats de la recherche

    searchLaunched: false,
    events: {
        "click .see-all-result": "onSeeAllClicked"
    },

    /**
     * @param  {Object} options must contains the "app" object
     */
    initialize: function (options) {
        var T = this;

        _.extend(T, options);
        T.template = _.template(T.template);

        T.resultViews = [];
        T.isPhone = $(window).width() < 767 ? true : false;

        // user
        T.userModel = new UserModel(T.app.user);
        var search_access = T.userModel.isAdmin() ? null : "public";
        T.searchQueryModel = new ArticleQueryModel({
            pageSize: (T.isPhone ? 3 : 5),
            access: search_access
        }, {
            pv5api: T.app.pv5api,
            minPublishedDate: T.app.minPublishedDate,
            maxPublishedDate: T.app.maxPublishedDate
        });
        T.searchQueryModel.setQueryString(T.searchQuery);

        // on vérifie que la zone est visible pour lancer la recherche
        T.checkSearchNextResultsVisibility();

        T.listenTo(T.app, "app:notify", T.notify);

        $(window).on("resize.rn", function () {
            T.checkSearchNextResultsVisibility();
        });

        $(window).on("scroll.rn", function () {
            T.checkSearchNextResultsVisibility();
        });

    },

    checkSearchNextResultsVisibility: function () {
        var T = this;
        if (T.isInViewport($(".search-next-results"))) {
            // show panel and launch search
            $(".search-next-results").addClass("show");

            if (!T.searchLaunched) {
                T.searchFromIndex();
            }
        }
        else {
            // hide panel
            $(".search-next-results").removeClass("show");
        }
    },

    searchFromIndex: function () {
        var T = this;

        T.searchLaunched = true;

        // listen query start loading
        T.listenTo(T.searchQueryModel, "request", T.onSearchStart);
        T.listenTo(T.searchQueryModel, "sync", T.onSearchEnd);
        T.listenTo(T.searchQueryModel, "error", T.onSearchError);

        // waiting for results
        T.listenTo(T.searchQueryModel.get("results"), "add", T.addOneArticleResult);
        T.listenTo(T.searchQueryModel.get("results"), "reset", T.addAllArticleResults);

        T.searchQueryModel.fetchFrom(parseInt(T.index) + 1); // on veut les suivants
    },

    isInViewport: function ($el) {
        var elementTop = $el.offset().top;
        var elementBottom = elementTop + $el.outerHeight();
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
        return elementBottom > viewportTop && elementTop < viewportBottom;
    },


    trackEvent: function (category, action, label) {
        var T = this;

        if (T.app.googleAnalytics.enable && _.isFunction(window.ga)) {
            debug("ga tracking event %s %s %s", category, action, label);
            window.ga("send", "event", category, action, label);
        }
    },

    /**
     * Display a sliding message from bottom
     * @param  {Object} data
     * {
     *      text:text,
     *      type:"error", //"error","info"
     *      timeout:10000
     *  }
     */
    notify: function (data) {
        var T = this;

        if (T.notifyTimer) {
            clearTimeout(T.notifyTimer);
        }

        T.$(".notify").addClass("show");
        T.$(".notify > p").attr("class", data.type).html(data.text);

        if (data.timeout) {
            T.notifyTimer = setTimeout(function () {
                T.notifyClose();
                T.notifyTimer = 0;
            }, data.timeout);
        }

    },

    notifyClose: function () {
        this.$(".notify").removeClass("show");
    },

    onSeeAllClicked: function () {
        window.location = '/search#' + this.searchQuery;
    },

    onSearchStart: function () {
        var T = this;
        // on affiche la notification de recherche
        T.notify({
            text: STR.search_in_progress,
            type: "info",
            timeout: 30000
        });
    },

    onSearchEnd: function () {
        var T = this,
            results = T.searchQueryModel.get("results");

        if (results.length) {
            T.notifyClose();
            T.$('.total-results').html(STR.number(T.searchQueryModel.get('total')) + ' ' + STR.search_results);
        } else {
            T.notify({
                text: STR.no_result,
                type: "warning",
                timeout: 3000
            });
        }
    },

    onSearchError: function (model, xhr) {
        var T = this;
        var message = STR.search_error;
        try {
            var error_js = JSON.parse(xhr.responseText);
            if (error_js.message) {
                message += " (" + error_js.message + ")";
            } else {
                message += " (" + xhr.status + ")";
            }
        } catch (e) {
            //
        }

        T.notify({
            text: message,
            type: "error",
            timeout: 5000
        });
    },

    addOneArticleResult: function (result, index) {
        var T = this,
            view = new ArticleResultView({
                model: result,
                template: templates.articleNextResult,
                pv5api: T.app.pv5api,
                rnapi: T.app.rnapi,
                userModel: T.userModel,
                queryModel: T.searchQueryModel,
                cropWidth: 200,
                cropHeight: 200,
                cropFontSize: 11,
                app: T.app,
                index: ((index !== false && index !== undefined) ? index : false),
                from: '/search#' + T.searchQuery
            });

        T.resultViews.push(view);
        T.$("#next-results").append(view.render().el);
    },

    /**
     * on ajoute des cases vides pour que l'alignement de la flexbox soit centré aussi sur la ddernière ligne
     */
    addEmptyCells: function ($el, classname) {
        for (var i = 0; i < 5; i++) {
            $el.append($("<div class=\"" + classname + " empty\"></div>"));
        }
    },

    addAllArticleResults: function () {
        var T = this;

        T.$("#next-results").css("visibility", "visible");

        T.$("#next-results").html("");

        T.resultViews.forEach(function (view) {
            T.stopListening(view);
            view.close();
            view.remove();
        });
        T.resultViews = [];

        if (T.searchQueryModel.get("results").length) {
            T.$("#next-results").removeClass("no-result");
            T.searchQueryModel.get("results").each(function (result, index) { T.addOneArticleResult(result, T.index + index + 1); });
            T.addEmptyCells(T.$("#next-results"), "page-result");
        }
        else {
            T.$("#next-results")
                .addClass("no-result")
                .html(STR.no_other_result);
        }
    },

    render: function () {
        debug("render");
        var T = this,
            context = T.searchQueryModel.toJSON();

        // &#10003; or &#10060;
        var charFromFilter = function (filter_name) {
            var name = filter_name.substr(2, filter_name.length - 4);
            return T.searchQueryModel.get("exclude" + name) ? "<span style='color:#f33'>&#10005;</span> " : "&#10003; ";
        };

        context.filters = [];
        var searchFilters = T.searchQueryModel.appliedFilters();
        $.each(searchFilters, function (key, value) {
            if (key == 'tfPublishedRanges') {
                if (value.start) {
                    context.filters.push(charFromFilter(key) + STR.date(value.start));
                }
                if (value.end) {
                    context.filters.push(charFromFilter(key) + STR.date(value.end));
                }
            }
            else {
                if (value.length) {
                    $.each(value, function (subkey, subvalue) {
                        if (key == 'tfPublicationGeolocsOr') {
                            context.filters.push(subvalue.city);
                        }
                        else if (key == 'tfThemes' || key == 'tfThemesOr') {
                            if (subvalue.l2) {
                                context.filters.push(charFromFilter(key) + STR["theme_l2_" + subvalue.l2]);
                            }
                            else {
                                context.filters.push(charFromFilter(key) + STR["theme_" + subvalue.l1]);
                            }
                        }
                        else if (key == 'tfHistoPeriods') {
                            var ref_period = _.findWhere(HistoPeriodList, { key: subvalue });
                            if (ref_period) {
                                context.filters.push(ref_period.label);
                            }
                            else {
                                context.filters.push(subvalue);
                            }
                        }
                        else if (key == 'tfPublicationGeotagsOr') {
                            var geotag = subvalue.split("_", 2)[1];
                            context.filters.push(charFromFilter("tfGeotagsOr") + geotag); // on renomme pour corriger un melimelo dans le paramètre choisi pour geotag
                        }
                        else {
                            context.filters.push(charFromFilter(key) + subvalue);
                        }
                    });
                }
            }
        });

        T.$el.html(T.template(context));
        return T;
    },

    /**
     * close each sub view and stop listening
     */
    close: function () {
        var T = this;

        T.resultViews.forEach(function (view) {
            T.stopListening(view);
            view.close();
            view.remove();
        });
        T.resultViews = null;

        $(document).off(".rn");
        $(window).off(".rn");

        T.stopListening();
        T.undelegateEvents();
    }

});